import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import TagSelector from './components/TagSelector';
import { useTagsHook } from '../../Hooks/communicators/useTagsHook';
import { useSelector } from 'react-redux';
import { useNavigationHook } from '../../Hooks/useNavigationHook';

export default function Tags() {
    const { returnSelectedTagPage } = useTagsHook();
    const {
        accessToken,
        refreshToken,
        UID,
    } = useSelector((state: any) => state.auth.value);
    const {
        navigateTo
    } = useNavigationHook();

    const checkAuth = () => {
        if (accessToken === '' || refreshToken === '' || UID === '') {
            navigateTo('/');
        };
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <div className='flex justify-center items-center flex-col'>
            <Navbar />
            <TagSelector />
            {returnSelectedTagPage()}
        </div>
    )
}
